// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input--search {
  position: relative;
  width: 100%;
  margin-top: -1px;
  background-color: #fff;
  z-index: 22;
  border-radius: 0 0 24px 24px;
  height: 45px;
}

.chat__play-visualizer {
  display: flex;
}

.chat__message-voice {
  width: 230px;
  object-fit: contain;
}

.chat-search {
  caret-color: white;
  padding-left: 7px;
  background-color: #fff;
  transform: translateY(-50%);
  height: 75px;
  border-top: 1px solid rgb(0, 0, 0, 0.27);
  border-radius: 0 0 24px 24px;
  width: 100%;
  color: white;
  border-left: none;
  border-bottom: none;
  border-right: none;
  font-weight: 500;
  box-sizing: border-box;
  color: #000000;
  font-family: "Open Sans";
  font-size: 24px;
  letter-spacing: -0.5px;
  line-height: 24px;
}

.chat-search::placeholder {
  opacity: 0.23;
  color: #000000;
  font-family: "Open Sans";
  font-size: 24px;
  letter-spacing: -0.5px;
  line-height: 24px;
}

.chat__map-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}

textarea:focus,
input:focus {
  outline: none;
}

.chat-container {
  width: 1100px;
  height: 500px;
  max-height: 100%;
  overflow-y: auto;
  border-radius: 24px 24px 0 0;
  background-color: #ffffff;
  box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 40px;
  margin-top: 40px;
  z-index: 22;
}

/* Style the scrollbar */
.chat-container::-webkit-scrollbar {
  width: 16px;
  /* Adjust the width of the scrollbar */
}

/* Track styles (the area around the thumb) */
.chat-container::-webkit-scrollbar-track {
  background: rgba(137, 137, 137, 0.6);
  border-radius: 8px;
}

/* Handle styles (the draggable part of the scrollbar) */
.chat-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  /* Make it rounded */
  background-color: #e3e3e3;
  border: 5px solid transparent;
  background-clip: content-box;
}

.chat-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.chat__message-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 60%;
}

.chat__message-box.bot__message-box {
  flex-direction: column;
  align-items: flex-start;
}

.user__message-box {
  align-self: flex-end;
  justify-content: flex-end;
}

.chat-message {
  margin: 15px;
  padding: 16px;
  border-radius: 8px;
  max-width: 70%;
}

.chat__image {
  width: 100%;
}

.bot-message {
  background: #c5e1ea;
  color: #000;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  border-radius: 16px;
}

.user-message {
  background-color: #f8f9fa;
  color: #000;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  border-radius: 16px;
}

.user-message p {
  all: unset;
}

.user-message .chat__play-button {
  background-color: #E84057;
}

.bot-message p {
  all: unset;
}

.bot__image {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: 15px;
  /* background-image:  url('./Chat/icons8-porsche-48.png'),linear-gradient(red,rgb(195, 0, 0)); */
  background-size: 85%;
  background-position: center;
  background-repeat: repeat;
}

.home__container {
  width: 100%;
  height: 100%;

  margin: 0 auto;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (max-width: 425px) {
    padding: 0 10px;
  }
}




.home--chat__ai {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.home__chat-ask {
  font-size: 36px;
  margin: 20px 0;

  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}

.home__chat-open {
  margin-right: 15px;

  color: #ffffff;
  font-size: 15px;
  font-weight: 300;

  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
}

.home--chat__fullChat {
  display: flex;
  align-items: center;
}

/* typing animation */

.chat-bubble {
  background-color: #e6f8f1;
  padding: 16px 28px;
  -webkit-border-radius: 20px;
  -webkit-border-bottom-left-radius: 2px;
  -moz-border-radius: 20px;
  -moz-border-radius-bottomleft: 2px;
  border-radius: 20px;
  border-bottom-left-radius: 2px;
  display: inline-block;
}

.typing {
  align-items: center;
  display: flex;
  height: 17px;
}

.typing .dot {
  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;
  background-color: #c9c9c9;
  border-radius: 50%;
  height: 7px;
  margin-right: 4px;
  vertical-align: middle;
  width: 7px;
  display: inline-block;
}

.typing .dot:nth-child(1) {
  animation-delay: 200ms;
}

.typing .dot:nth-child(2) {
  animation-delay: 300ms;
}

.typing .dot:nth-child(3) {
  animation-delay: 400ms;
}

.typing .dot:last-child {
  margin-right: 0;
}

@keyframes mercuryTypingAnimation {
  0% {
    transform: translateY(0px);
    background-color: #c9c9c9;
  }

  28% {
    transform: translateY(-7px);
    background-color: #858585;
  }

  44% {
    transform: translateY(0px);
    background-color: #cecece;
  }
}

.input--voice {
  border-radius: 12px;
  background-color: #006480;
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 14px;
  top: -26px;
}

.audio-recorder.custom {
  background-color: #E84057;
  box-shadow: none;
  transition: none;
}

.audio-recorder.recording {
  background-color: #E84057 !important;

}

.visualizer-box {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.visualizer-line {
  position: absolute;
  top: 0;
  left: 50%;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, red, blue);
  /* Change colors as needed */
  transform: translateX(-50%);
}

.input--send {
  border-radius: 12px;
  background-color: #006480;
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  top: -19px;
}

.sound-wave {
  width: 100%;
  /* Set the width to fill the container */
  height: 80px;
  /* Set a fixed height for visibility */
  background-color: #007bff;
  /* Set a background color */
}

.button-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.audio-controls,
.video-controls {
  margin-bottom: 20px;
}

.audio-player,
.video-player {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.audio-player,
.video-player,
.recorded-player {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.live-player {
  height: 200px;
  width: 400px;
  border: 1px solid #646cff;
  margin-bottom: 30px;
}

.recorded-player video {
  height: 400px;
  width: 800px;
}

.chat__play-button,
.chat__transcript-button {
  background-color: #000;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  cursor: pointer;
  padding: 0;
  padding-left: 4px;
}

.chat__transcript-button {
  background-color: #8bcf9e;
}

.chat__play-button.bot,
.chat__transcript-button.bot {
  width: 65px;
}

.chat__transcript-button.bot {
  padding-top: 5px;
  padding-left: 0;
}

.chat__transcript-button.bot div {
  display: flex;
  flex-direction: column;
  align-items: left;
  height: 20px;
}

.chat__transcript-button.bot div span {
  display: inline-block;
  width: 20px;
  height: 2px;
  background: white;
  margin-bottom: 3px;
  margin-right: 5px;
}

.chat__transcript-button.bot div span:last-child {
  width: 10px;
}

.chat__transcript-text {
  display: none;
}

.message-date {
  font-size: 10px;
  font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/Chat.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,wCAAwC;EACxC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;EAE7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gGAAgG;EAChG,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,eAAe;EACjB;AACF;;;;;AAKA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;;EAEd;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,sCAAsC;EACtC,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2DAA2D;EAC3D,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".input--search {\n  position: relative;\n  width: 100%;\n  margin-top: -1px;\n  background-color: #fff;\n  z-index: 22;\n  border-radius: 0 0 24px 24px;\n  height: 45px;\n}\n\n.chat__play-visualizer {\n  display: flex;\n}\n\n.chat__message-voice {\n  width: 230px;\n  object-fit: contain;\n}\n\n.chat-search {\n  caret-color: white;\n  padding-left: 7px;\n  background-color: #fff;\n  transform: translateY(-50%);\n  height: 75px;\n  border-top: 1px solid rgb(0, 0, 0, 0.27);\n  border-radius: 0 0 24px 24px;\n  width: 100%;\n  color: white;\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n  font-weight: 500;\n  box-sizing: border-box;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  letter-spacing: -0.5px;\n  line-height: 24px;\n}\n\n.chat-search::placeholder {\n  opacity: 0.23;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  letter-spacing: -0.5px;\n  line-height: 24px;\n}\n\n.chat__map-box {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n}\n\ntextarea:focus,\ninput:focus {\n  outline: none;\n}\n\n.chat-container {\n  width: 1100px;\n  height: 500px;\n  max-height: 100%;\n  overflow-y: auto;\n  border-radius: 24px 24px 0 0;\n  background-color: #ffffff;\n  box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.05);\n  position: relative;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 40px;\n  margin-top: 40px;\n  z-index: 22;\n}\n\n/* Style the scrollbar */\n.chat-container::-webkit-scrollbar {\n  width: 16px;\n  /* Adjust the width of the scrollbar */\n}\n\n/* Track styles (the area around the thumb) */\n.chat-container::-webkit-scrollbar-track {\n  background: rgba(137, 137, 137, 0.6);\n  border-radius: 8px;\n}\n\n/* Handle styles (the draggable part of the scrollbar) */\n.chat-container::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  /* Make it rounded */\n  background-color: #e3e3e3;\n  border: 5px solid transparent;\n  -webkit-background-clip: content-box;\n  background-clip: content-box;\n}\n\n.chat-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.chat__message-box {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-end;\n  width: 60%;\n}\n\n.chat__message-box.bot__message-box {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.user__message-box {\n  align-self: flex-end;\n  justify-content: flex-end;\n}\n\n.chat-message {\n  margin: 15px;\n  padding: 16px;\n  border-radius: 8px;\n  max-width: 70%;\n}\n\n.chat__image {\n  width: 100%;\n}\n\n.bot-message {\n  background: #c5e1ea;\n  color: #000;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 24px;\n  border-radius: 16px;\n}\n\n.user-message {\n  background-color: #f8f9fa;\n  color: #000;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 24px;\n  border-radius: 16px;\n}\n\n.user-message p {\n  all: unset;\n}\n\n.user-message .chat__play-button {\n  background-color: #E84057;\n}\n\n.bot-message p {\n  all: unset;\n}\n\n.bot__image {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  margin-right: 5px;\n  margin-bottom: 15px;\n  /* background-image:  url('./Chat/icons8-porsche-48.png'),linear-gradient(red,rgb(195, 0, 0)); */\n  background-size: 85%;\n  background-position: center;\n  background-repeat: repeat;\n}\n\n.home__container {\n  width: 100%;\n  height: 100%;\n\n  margin: 0 auto;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  @media screen and (max-width: 425px) {\n    padding: 0 10px;\n  }\n}\n\n\n\n\n.home--chat__ai {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.home__chat-ask {\n  font-size: 36px;\n  margin: 20px 0;\n\n  @media screen and (max-width: 600px) {\n    font-size: 24px;\n  }\n}\n\n.home__chat-open {\n  margin-right: 15px;\n\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 300;\n\n  @media screen and (max-width: 600px) {\n    font-size: 14px;\n  }\n}\n\n.home--chat__fullChat {\n  display: flex;\n  align-items: center;\n}\n\n/* typing animation */\n\n.chat-bubble {\n  background-color: #e6f8f1;\n  padding: 16px 28px;\n  -webkit-border-radius: 20px;\n  -webkit-border-bottom-left-radius: 2px;\n  -moz-border-radius: 20px;\n  -moz-border-radius-bottomleft: 2px;\n  border-radius: 20px;\n  border-bottom-left-radius: 2px;\n  display: inline-block;\n}\n\n.typing {\n  align-items: center;\n  display: flex;\n  height: 17px;\n}\n\n.typing .dot {\n  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;\n  background-color: #c9c9c9;\n  border-radius: 50%;\n  height: 7px;\n  margin-right: 4px;\n  vertical-align: middle;\n  width: 7px;\n  display: inline-block;\n}\n\n.typing .dot:nth-child(1) {\n  animation-delay: 200ms;\n}\n\n.typing .dot:nth-child(2) {\n  animation-delay: 300ms;\n}\n\n.typing .dot:nth-child(3) {\n  animation-delay: 400ms;\n}\n\n.typing .dot:last-child {\n  margin-right: 0;\n}\n\n@keyframes mercuryTypingAnimation {\n  0% {\n    transform: translateY(0px);\n    background-color: #c9c9c9;\n  }\n\n  28% {\n    transform: translateY(-7px);\n    background-color: #858585;\n  }\n\n  44% {\n    transform: translateY(0px);\n    background-color: #cecece;\n  }\n}\n\n.input--voice {\n  border-radius: 12px;\n  background-color: #006480;\n  width: 55px;\n  height: 55px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 14px;\n  top: -26px;\n}\n\n.audio-recorder.custom {\n  background-color: #E84057;\n  box-shadow: none;\n  transition: none;\n}\n\n.audio-recorder.recording {\n  background-color: #E84057 !important;\n\n}\n\n.visualizer-box {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n\n.visualizer-line {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(to bottom, red, blue);\n  /* Change colors as needed */\n  transform: translateX(-50%);\n}\n\n.input--send {\n  border-radius: 12px;\n  background-color: #006480;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 20px;\n  top: -19px;\n}\n\n.sound-wave {\n  width: 100%;\n  /* Set the width to fill the container */\n  height: 80px;\n  /* Set a fixed height for visibility */\n  background-color: #007bff;\n  /* Set a background color */\n}\n\n.button-flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.audio-controls,\n.video-controls {\n  margin-bottom: 20px;\n}\n\n.audio-player,\n.video-player {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.audio-player,\n.video-player,\n.recorded-player {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.live-player {\n  height: 200px;\n  width: 400px;\n  border: 1px solid #646cff;\n  margin-bottom: 30px;\n}\n\n.recorded-player video {\n  height: 400px;\n  width: 800px;\n}\n\n.chat__play-button,\n.chat__transcript-button {\n  background-color: #000;\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 10px;\n  cursor: pointer;\n  padding: 0;\n  padding-left: 4px;\n}\n\n.chat__transcript-button {\n  background-color: #8bcf9e;\n}\n\n.chat__play-button.bot,\n.chat__transcript-button.bot {\n  width: 65px;\n}\n\n.chat__transcript-button.bot {\n  padding-top: 5px;\n  padding-left: 0;\n}\n\n.chat__transcript-button.bot div {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  height: 20px;\n}\n\n.chat__transcript-button.bot div span {\n  display: inline-block;\n  width: 20px;\n  height: 2px;\n  background: white;\n  margin-bottom: 3px;\n  margin-right: 5px;\n}\n\n.chat__transcript-button.bot div span:last-child {\n  width: 10px;\n}\n\n.chat__transcript-text {\n  display: none;\n}\n\n.message-date {\n  font-size: 10px;\n  font-weight: 300;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
